module.exports = __webpack_public_path__ + "media/images/logos/WS_illustration-site-vitrine-2022-34-34f49d71ef5904edab241db748234223.svg";